import type { SupportTicketTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import { memo } from "react";
import { LegacyTimelineEvent } from "./events/legacy-timeline-event";
import { MessageReceivedEvent } from "./events/message-received-event";
import { MessageSentEvent } from "./events/message-sent-event";
import { RulesTriggeredEvent } from "./events/rules-triggered/rules-triggered-event";
import { SupportTicketAssignedEvent } from "./events/support-ticket-assigned-event";
import { SupportTicketCreatedEvent } from "./events/support-ticket-created-event";
import { SupportTicketMigratedFromV1Event } from "./events/support-ticket-migrated-from-v1-event";
import { SupportTicketPriorityChangedEvent } from "./events/support-ticket-priority-changed-event";
import { SupportTicketReadEvent } from "./events/support-ticket-read-event";
import { SupportTicketStatusChangedEvent } from "./events/support-ticket-status-changed-event";
import { TagAddedEvent } from "./events/tag-added-event";
import { TagRemovedEvent } from "./events/tag-removed-event";
import { ThreadCreatedEvent } from "./events/thread-created-event";
import { TopicHandoffEvent } from "./events/topic-handoff-event";

export const TimelineEventCard = memo(function TimelineEventCard({
  event,
}: {
  event: SupportTicketTimelineEventResponse;
}) {
  switch (event.eventType) {
    case "support_ticket_created":
      return <SupportTicketCreatedEvent data={event.eventData} event={event} />;
    case "support_ticket_status_changed":
      return (
        <SupportTicketStatusChangedEvent data={event.eventData} event={event} />
      );
    case "support_ticket_priority_changed":
      return (
        <SupportTicketPriorityChangedEvent
          data={event.eventData}
          event={event}
        />
      );
    case "support_ticket_assigned":
      return (
        <SupportTicketAssignedEvent data={event.eventData} event={event} />
      );
    case "support_ticket_read":
      return <SupportTicketReadEvent event={event} />;
    case "topic_handoff":
      return <TopicHandoffEvent data={event.eventData} event={event} />;
    case "message_sent":
      return <MessageSentEvent data={event.eventData} event={event} />;
    case "message_received":
      return <MessageReceivedEvent data={event.eventData} event={event} />;
    case "thread_created":
      return <ThreadCreatedEvent data={event.eventData} event={event} />;
    case "tag_added":
      return <TagAddedEvent data={event.eventData} event={event} />;
    case "tag_removed":
      return <TagRemovedEvent data={event.eventData} event={event} />;
    case "rules_triggered":
      return <RulesTriggeredEvent data={event.eventData} event={event} />;
    case "support_ticket_migrated_from_v1":
      return (
        <SupportTicketMigratedFromV1Event
          data={event.eventData}
          event={event}
        />
      );
    case "legacy_timeline_event":
      return <LegacyTimelineEvent data={event.eventData} event={event} />;
    default:
      return null;
  }
});
